export default __webpack_public_path__ + "static/media/boiler-small.8fa0962b.png";